var IsArcCorner = function (radius) {
    return ((radius.x > 0) && (radius.y > 0));
}

export default IsArcCorner;